<template>
  <li class="p-content-plan-manual-trend-keywords__item">
    <EllipsisTip>{{ keyword.word }}</EllipsisTip>
    <div
      class="p-contentplans-graph__bar"
      :data-count="keyword.count"
      :style="{ width: barW + '%' }"
    ></div>
  </li>
</template>

<script>
import EllipsisTip from '@/components/EllipsisTip';
export default {
  props: {
    keyword: {
      type: Object,
      required: true
    },
    max: {
      type: Number,
      required: true
    }
  },
  components: {
    EllipsisTip
  },
  computed: {
    barW() {
      return (this.keyword.count / this.max) * 100;
    }
  }
};
</script>
